import type { ReactNode } from "react";

import { Box, Container, Flex, Image } from "@chakra-ui/react";

type Props = {
  appLogoSrc: string;
  leftSlot?: ReactNode;
  navigationSlot?: ReactNode;
};

export const AppHeader = ({ appLogoSrc, leftSlot, navigationSlot }: Props) => {
  return (
    <Flex
      alignItems="center"
      backgroundColor="bg"
      justifyContent="space-between"
      position="sticky"
      px={{ base: "16px", lg: "40px" }}
      py={{ base: "8px", lg: "12px" }}
      top={0}
      w="full"
      zIndex="sticky"
    >
      <Image src={appLogoSrc} zIndex={1} />
      {navigationSlot && (
        <Box
          hideBelow="desktop"
          left="50%"
          position="absolute"
          transform="translateX(-50%)"
          w="full"
          zIndex={0}
        >
          <Container maxW="lg">{navigationSlot}</Container>
        </Box>
      )}
      {leftSlot && (
        <Box
          mr={{
            base: "-8px",
            lg: "0",
          }}
          pl={
            navigationSlot
              ? { base: "16px", md: "0" }
              : { base: "16px", lg: "32px", md: "24px" }
          }
          zIndex={1}
        >
          {leftSlot}
        </Box>
      )}
    </Flex>
  );
};
